import React from 'react';

const Input = React.forwardRef(({ name, id, text, type, value, placeholder, register}, ref) => {

    return (
        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                htmlFor={name}>
                {text}
            </label>
            {type === 'number' ? (
                <div className="relative">
                    <input
                        className="block w-full text-gray-900 dark:text-white border-2 rounded-lg py-3 px-4 pr-12 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 shadow-sm hover:shadow-md focus:shadow-lg bg-gray-100 dark:bg-gray-500 border-gray-400 dark:border-gray-400 focus:bg-white dark:focus:bg-gray-600"
                        id={id} 
                        type="number" 
                        placeholder={placeholder} 
                        defaultValue={value || '1'}
                        ref={ref}
                        {...register(name, { valueAsNumber: true })}
                        min="0"
                        step="1"
                    />
                    <div className="absolute inset-y-0 right-0 flex flex-col">
                        <button
                            type="button"
                            className="flex-1 px-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-tr-lg transition-colors duration-200"
                            onClick={() => {
                                const input = document.getElementById(id);
                                if (input) {
                                    const currentValue = parseInt(input.value) || 0;
                                    input.value = currentValue + 1;
                                    input.dispatchEvent(new Event('input', { bubbles: true }));
                                }
                            }}
                        >
                            <i className="fas fa-chevron-up text-xs"></i>
                        </button>
                        <button
                            type="button"
                            className="flex-1 px-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-br-lg transition-colors duration-200"
                            onClick={() => {
                                const input = document.getElementById(id);
                                if (input) {
                                    const currentValue = parseInt(input.value) || 1;
                                    input.value = Math.max(0, currentValue - 1);
                                    input.dispatchEvent(new Event('input', { bubbles: true }));
                                }
                            }}
                        >
                            <i className="fas fa-chevron-down text-xs"></i>
                        </button>
                    </div>
                </div>
            ) : (
                <input
                    className="block w-full text-gray-900 dark:text-white border-2 rounded-lg py-3 px-4 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 shadow-sm hover:shadow-md focus:shadow-lg bg-gray-50 dark:bg-gray-600 border-gray-300 dark:border-gray-500 focus:bg-white dark:focus:bg-gray-700"
                    id={id} 
                    type={type} 
                    placeholder={placeholder} 
                    defaultValue={value} 
                    ref={ref} 
                    {...register(name)}
                />
            )} 
        </div>
    );
  });

export default Input;
